import { useCallback } from 'react';
import { Offer } from '@funtech-int/yango-shared';

import { useSendWebAnalytics } from '@/shared/hooks/useSendWebAnalytics';

const EVENT_BASE_NAME = 'BUY_SUBSCRIPTION_SUCCESS';

function getUniversalAnalyticsEcommerceData(offer?: Offer | null) {
    if (!offer) return {};

    return {
        transactionId: offer.eventSessionId,
    };
}

export const useSendSuccessPurchaseEvent = (offer?: Offer | null) => {
    const sendWebAnalytics = useSendWebAnalytics();

    return useCallback(() => {
        const webAnalyticsEventAffix = offer?.offerTexts?.customTexts?.webAnalyticsEventAffix;

        return sendWebAnalytics(
            webAnalyticsEventAffix
                ? `${webAnalyticsEventAffix.toUpperCase()}.${EVENT_BASE_NAME}`
                : EVENT_BASE_NAME,
            getUniversalAnalyticsEcommerceData(offer)
        );
    }, [sendWebAnalytics, offer]);
};
